import { render, staticRenderFns } from "./Overijssel.vue?vue&type=template&id=2f482f25&"
var script = {}
import style0 from "./Overijssel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Overijssel.vue"
export default component.exports